import Repository from '@/services/Repository';

const resource = '/terms';

export default {
  fetch() {
    return Repository.get(`${resource}/`);
  },
  post(newContent) {
    return Repository.post(`${resource}/`, newContent);
  },
  put(content) {
    return Repository.put(`${resource}/id/${content.id}`, content);
  },
  delete(contentId) {
    return Repository.delete(`${resource}/id/${contentId}`);
  },
};
